import { useMutation } from "@apollo/client"
import CustomButton from "components/Atoms/CustomButton"
import { useTripStepGraphVariables } from "graphql/trip/trip.hooks"
import { ADD_BOOKING_TO_TRIP } from "graphql/trip/trip.mutations"
import {
  TRIP_RECOMMENDATIONS,
  TRIP_STEP_GRAPH,
} from "graphql/trip/trip.queries.gql"

import { getErrors } from "hooks/useErrors"
import { addScheduleToTrip } from "models/scheduling.yup"
import React from "react"
import { useDispatch } from "react-redux"
import { VEHICLE_REMOVE_RECOMMENDATION_ROUTE } from "store/vehicle.redux"
import AppToaster from "utils/AppToaster"
import { useTrip } from "./TripContext"

const AddScheduleMutation = props => {
  const variables = useTripStepGraphVariables()
  const trip = useTrip()
  const dispatch = useDispatch()
  const [addSchedule, { loading }] = useMutation(ADD_BOOKING_TO_TRIP, {
    refetchQueries: [
      {
        query: TRIP_RECOMMENDATIONS,
        variables: {
          uuid: props?.tripUuid,
          vehicleLatitude: trip?.lat,
          vehicleLongitude: trip?.lng,
        },
      },
      {
        query: TRIP_STEP_GRAPH,
        variables,
      },
    ],
    onCompleted(data) {
      AppToaster.show({
        message: `Booking for the trip`,
        intent: "success",
        icon: "confirm",
      })
      dispatch({
        type: VEHICLE_REMOVE_RECOMMENDATION_ROUTE,
        payload: props?.plotCommodityId,
      })
      props.onCompleted(data)
    },
    onError() {
      AppToaster.show({
        message: "Unable to add booking",
        intent: "danger",
        icon: "cross",
      })
    },
  })

  function handleClick(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    const state = {
      // sourceDepot: props.sour
      sourceDepot: props?.sourceDepot,
      destinationDepot: props?.destinationDepot,
      plotCommodityId: props?.plotCommodityId,
      skuType: props?.skuType,
      requiredQuantity: props?.requiredQuantity,
      tripUuid: props.tripUuid,
      vehicleLat: trip?.lat,
      vehicleLon: trip?.lng,
    }
    const errors: any = getErrors({
      schema: addScheduleToTrip,
      state,
      abortEarly: true,
    })
    if (errors?.latest) {
      AppToaster.show({
        message: errors?.latest,
        intent: "danger",
        icon: "cross",
      })
      return
    } else {
      addSchedule({
        variables: state,
      })
    }
  }
  return (
    <CustomButton
      loading={loading}
      onClick={handleClick}
      className="ml-3"
      dark
      icon="plus"
      text="Schedule"
    />
  )
}

export default AddScheduleMutation
